module.exports = __webpack_public_path__ + "img/icon-file.c831457c.png";